import React, { memo, forwardRef } from 'react';

const InnerClassFormatter = ({ value, className }, ref) => {
    return (
        <span ref={ref} className={className}>
            {value}
        </span>
    );
};

export default memo(forwardRef(InnerClassFormatter));
